

const Contact = () => {
  

 
  return (
    <div className='d-flex flex-column gap-2 '>
        <a href='tel:+972 54-222-0977' className='text-decoration-none text-white '>+972 54-222-0977</a>
        <a href='mailto:seq.video@gmail.com' className='text-decoration-none text-white'>seq.video@gmail.com</a>
        <span>Halimon Street, Ramot Hashavim, Israel</span>
  
    </div>
  )
}

export default Contact